var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bootstrap-canvas"},[_c('div',{staticClass:"container-fluid"},[_c('app-filter',{attrs:{"groups":_vm.groups}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }